import React, { Component } from 'react';
import { Card, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import CopyIcon from 'material-ui/svg-icons/content/content-copy';

const BRAND_BLUE = '#284263';

const styles = {
    page: { padding: '20px 28px 60px', maxWidth: 840, margin: '0 auto', color: '#1f2937' },
    title: { fontSize: 22, fontWeight: 700, color: BRAND_BLUE, marginBottom: 4 },
    subtitle: { fontSize: 13, color: '#6b7280', marginBottom: 20 },
    card: { padding: '4px 4px 12px' },
    h2: { fontSize: 15, fontWeight: 700, color: BRAND_BLUE, marginTop: 20, marginBottom: 6 },
    p: { fontSize: 14, lineHeight: 1.6, margin: '4px 0' },
    ol: { fontSize: 14, lineHeight: 1.7, paddingLeft: 20, margin: '6px 0' },
    actions: { marginTop: 16 },
    copied: { fontSize: 12, color: '#2e7d32', marginLeft: 10 },
};

// Plain text version - what actually gets copied to the clipboard for pasting into an email.
const PLAIN_TEXT = `Hoe wij ongeldige kliks eruit filteren

Niet elke klik op een advertentie wordt in rekening gebracht. Wij filteren automatisch kliks eruit die niet van een echte, geïnteresseerde bezoeker lijken te komen. Dit gebeurt op een paar manieren:

1. Bekende bots en scanners
Bepaalde bezoekers herkennen we direct als geautomatiseerd systeem (bijvoorbeeld zoekmachine-crawlers, scanners of testtools) in plaats van een echte persoon. Deze kliks tellen nooit mee.

2. Verdachte IP-adressen
Adressen waarvan we weten dat ze eerder misbruik hebben gemaakt, staan op een zwarte lijst. Kliks vanaf zo'n adres tellen niet mee.

3. Ongebruikelijk snel klikgedrag
Als er in korte tijd veel te veel kliks vanaf dezelfde plek binnenkomen (veel meer dan een mens fysiek zou kunnen), zien we dat als geautomatiseerd verkeer. Die kliks tellen niet mee, en dat adres wordt tijdelijk geblokkeerd.

4. Dubbele kliks
Klikt dezelfde bezoeker meerdere keren op dezelfde dag op dezelfde advertentie/link, dan telt alleen de eerste (paar) klik(ken) mee. Herhaalde kliks daarna worden gezien als dubbel en niet gefactureerd.

Kortom: alleen kliks die met grote waarschijnlijkheid van een echte, unieke bezoeker komen, worden in rekening gebracht. Twijfelgevallen (bots, herhaalverkeer, bekende misbruik-adressen) worden er automatisch uitgefilterd.`;

class FraudMeasures extends Component {
    state = { copied: false };

    handleCopy = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(PLAIN_TEXT).then(() => {
                this.setState({ copied: true });
                setTimeout(() => this.setState({ copied: false }), 2500);
            });
        }
    };

    render() {
        return (
            <div style={styles.page}>
                <div style={styles.title}>Hoe wij ongeldige kliks eruit filteren</div>
                <div style={styles.subtitle}>
                    Dit verhaal kun je 1-op-1 doorsturen naar klanten die vragen hebben over hun kliktellingen.
                </div>

                <Card style={styles.card}>
                    <CardText>
                        <p style={styles.p}>
                            Niet elke klik op een advertentie wordt in rekening gebracht. Wij filteren
                            automatisch kliks eruit die niet van een echte, geïnteresseerde bezoeker
                            lijken te komen. Dit gebeurt op een paar manieren:
                        </p>

                        <div style={styles.h2}>1. Bekende bots en scanners</div>
                        <p style={styles.p}>
                            Bepaalde bezoekers herkennen we direct als geautomatiseerd systeem
                            (bijvoorbeeld zoekmachine-crawlers, scanners of testtools) in plaats van
                            een echte persoon. Deze kliks tellen nooit mee.
                        </p>

                        <div style={styles.h2}>2. Verdachte IP-adressen</div>
                        <p style={styles.p}>
                            Adressen waarvan we weten dat ze eerder misbruik hebben gemaakt, staan op
                            een zwarte lijst. Kliks vanaf zo'n adres tellen niet mee.
                        </p>

                        <div style={styles.h2}>3. Ongebruikelijk snel klikgedrag</div>
                        <p style={styles.p}>
                            Als er in korte tijd veel te veel kliks vanaf dezelfde plek binnenkomen
                            (veel meer dan een mens fysiek zou kunnen), zien we dat als geautomatiseerd
                            verkeer. Die kliks tellen niet mee, en dat adres wordt tijdelijk geblokkeerd.
                        </p>

                        <div style={styles.h2}>4. Dubbele kliks</div>
                        <p style={styles.p}>
                            Klikt dezelfde bezoeker meerdere keren op dezelfde dag op dezelfde
                            advertentie/link, dan telt alleen de eerste (paar) klik(ken) mee. Herhaalde
                            kliks daarna worden gezien als dubbel en niet gefactureerd.
                        </p>

                        <p style={{ ...styles.p, marginTop: 16 }}>
                            <strong>Kortom:</strong> alleen kliks die met grote waarschijnlijkheid van
                            een echte, unieke bezoeker komen, worden in rekening gebracht. Twijfelgevallen
                            (bots, herhaalverkeer, bekende misbruik-adressen) worden er automatisch
                            uitgefilterd.
                        </p>

                        <div style={styles.actions}>
                            <FlatButton label="Kopieer tekst" icon={<CopyIcon />} onClick={this.handleCopy} primary />
                            {this.state.copied && <span style={styles.copied}>Gekopieerd!</span>}
                        </div>
                    </CardText>
                </Card>
            </div>
        );
    }
}

export default FraudMeasures;



// WEBPACK FOOTER //
// ./src/misc/FraudMeasures.js